import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";

// icons
import {
  FaUserTie,
  FaCar,
  FaRupeeSign,
  FaClock,
  FaCalendarAlt,
} from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import { BsBoxSeam } from "react-icons/bs";

const Last5ServicesApi = async (selectedFilter) => {
  try {
    const res = await axInst.post("/pvin/last_five_service", selectedFilter);
    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch financial details");
  }
};

const Last5Services = () => {
  const selectedFilter = useSelector(
    (state) => state.filtersPvin.selectedFilter
  );

  const {
    data: Last5ServicesData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["Last5Services", selectedFilter],
    queryFn: () => Last5ServicesApi(selectedFilter),
    cacheTime: 0,
    staleTime: 0,
    enabled: Object.keys(selectedFilter).length > 0,
  });

  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );

  if (isError)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <p className="text-red-500">Error Occurred</p>
      </div>
    );

  const serviceDetails = Last5ServicesData?.Last_5_Service_Details ?? [];

  const toCamelCase = (str) => {
    if (!str) return "N/A";
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <div className="w-full bg-white rounded-lg shadow-sm p-2 relative">
      <h2 className="pb-1 text-base font-semibold text-[#4c4c4c] border-b border-gray-200 mb-2">
        Last 5 Services
      </h2>

      {Array.isArray(serviceDetails) && serviceDetails.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-2">
          {serviceDetails.map((item, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl shadow-md p-2 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm font-semibold text-gray-800 flex items-center gap-1">
                  <MdCategory className="text-blue-500" />
                  {item.SR_SR_CAT_TYPE_CD || "N/A"}
                </h3>
              </div>

              <div className="text-[13px] text-gray-700 space-y-2 ">
                <p className="flex items-center gap-1  ">
                  <FaUserTie className="text-indigo-500 " />

                  <span className=" text-[14px] font-semibold text-[#575a60]">
                    {toCamelCase(item.DLR_NAME)}
                  </span>
                </p>
                <p className="flex items-center gap-1 border-b border-gray-200 pb-2">
                  <FaCalendarAlt className="text-blue-400" />
                  <span className="font-medium">Last Service :</span>
                  {item.LAST_SERVICE_DATE || "N/A"}
                </p>

                <p className="flex items-center gap-1">
                  <FaCar className="text-green-500" />
                  <span className="font-medium text-[#575a60]">
                    Vehicle No:
                  </span>{" "}
                  {item.VEHICLE_REGISTRATION_NUMBER || "N/A"}
                </p>
                <p className="flex items-center gap-1">
                  <BsBoxSeam className="text-yellow-500" />
                  <span className="font-medium text-[#575a60]">PPL:</span>{" "}
                  {item.SR_ASSET_PPL || "N/A"}
                </p>

                <p className="flex items-center gap-1">
                  <BsBoxSeam className="text-yellow-500" />
                  <span className="font-medium text-[#575a60]">PL:</span>{" "}
                  {item.SR_ASSET_PL || "N/A"}
                </p>
                <p className="flex items-center gap-1">
                  <BsBoxSeam className="text-yellow-500" />
                  <span className="font-medium text-[#575a60]">LOB:</span>{" "}
                  {item.SR_ASSET_LOB || "N/A"}
                </p>

                <p className="flex items-center gap-1">
                  <FaRupeeSign className="text-emerald-500" />
                  <span className="font-medium text-[#575a60]">Invoice:</span> ₹
                  {item.Bill_Amount?.toLocaleString() || 0}
                </p>
                <p className="flex items-center gap-1">
                  <FaClock className="text-orange-500" />
                  <span className="font-medium text-[#575a60]">
                    Service TAT (Days):
                  </span>{" "}
                  {item.TAT_Hours || "N/A"}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center text-gray-600">No data available</div>
      )}

      <WaterMark />
    </div>
  );
};

export default Last5Services;
